/** Gets initials from the name for the Avatar. */
export function defaultGetInitials(name = '') {
    const [first = '', last = ''] = name.split(' ');
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}
